// extracted by mini-css-extract-plugin
module.exports = {"root":"PartnerLogo_root__2SHmJ"};
    if(module.hot) {
      // 1586964020711
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  